import { ActionContext } from 'vuex';
import { Evnt } from '../../__types';

type State = {
  allEvents?: Evnt[];
  currentEvent?: null | Evnt;
  minimized?: boolean;
};

const state: State = {
  minimized: false,
};

const getters = {
  getMinimized: (state: State) => state.minimized,
};

const actions = {
  toggleMinimized({ commit, getters }: ActionContext<State, State>) {
    commit('changeMinimized', !getters.getMinimized);
  },
};

const mutations = {
  changeMinimized: (state: State, newMinimize: boolean) =>
    (state.minimized = newMinimize),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
